import { AnyAction } from "redux";

import * as types from "./types";

import { initialState } from ".";

export default function originsReducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case types.GET_ORIGIN_STATUS: {
      return {
        ...state,
        isFetchingOrigin: action.payload.isFetchingOrigin,
      };
    }
    case types.GET_ORIGIN_STATUS_SUCCESS: {
      return {
        ...state,
        isFetchingOrigin: action.payload.isFetchingOrigin,
        originStatus: [...action.payload.originStatus]
      };
    }
    case types.GET_ORIGIN_STATUS_ERROR: {
      return {
        ...state,
        isFetchingOrigin: false,
        hasError: action.payload.hasError,
      };
    }
    default:
      return state;
  }

} 